import { getQuestionIndicatorStyle, moduleColors, moduleBoxHWBr, moduleDesc } from "./utils";

const QuestionsNavigation = ({ questionRefs, otherActivityData }) => {

    const seenQuestions2 = new Set();

    const scrollToQuestion = (index) => {
        if (questionRefs.current[index]) {
            questionRefs.current[index].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }
    };

    return (
        <div className="section-full-border" style={{ flex: 1, height: "max-content", marginBottom: "30px", marginRight: "10px" }}>
            <h6 className="p-2 py-3" style={{ borderBottom: "1px solid #DFDFDF" }}>
                Questions
            </h6>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 15 }}>
                <div className="d-flex" style={{ gap: 10 }}>
                    <div style={{ backgroundColor: moduleColors.rightAnswer, ...moduleBoxHWBr }}></div>
                    <p style={moduleDesc} className="mb-0">Attempted</p>
                </div>
                <div className="d-flex" style={{ gap: 10 }}>
                    <div style={{ backgroundColor: "#fff", border: "1px solid #757589", ...moduleBoxHWBr }}></div>
                    <p style={moduleDesc} className="mb-0">Not Attempted</p>
                </div>
            </div>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, maxWidth: 238 }}>
                {
                    <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, maxWidth: 238 }}>
                        {otherActivityData && otherActivityData.question_set && otherActivityData.question_set
                            .filter(activity => {
                                const isDuplicate = seenQuestions2.has(activity.question_id);
                                seenQuestions2.add(activity.question_id);
                                return !isDuplicate;
                            })
                            .slice(0, Math.ceil(otherActivityData.question_set.length))
                            .map((activity, index) => (
                                <div
                                    key={activity.question_id}
                                    onClick={() => scrollToQuestion(index)}
                                    style={{ ...getQuestionIndicatorStyle(activity, index, index), border: "2px solid black" }}
                                >
                                    {index + 1}
                                </div>
                            ))}
                    </div>

                }
            </div>

        </div>
    );

}

export default QuestionsNavigation;